var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAccountTransfer = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1748 20.1748C15.6304 19.7192 16.3696 19.7192 16.8252 20.1748L17.6865 21.0371C17.8818 21.2324 17.8818 21.5489 17.6865 21.7441C17.4912 21.9392 17.1747 21.9393 16.9795 21.7441L16.5 21.2646V22.667C16.4998 22.943 16.276 23.167 16 23.167C15.724 23.167 15.5002 22.943 15.5 22.667V21.2646L15.0205 21.7441C14.8253 21.9393 14.5088 21.9392 14.3135 21.7441C14.1182 21.5489 14.1182 21.2324 14.3135 21.0371L15.1748 20.1748ZM19 9.33301C20.6567 9.33301 21.9998 10.6763 22 12.333V15.666C22 17.3229 20.6569 18.666 19 18.666H13C11.3431 18.666 10 17.3229 10 15.666V12.333C10.0002 10.6763 11.3433 9.33301 13 9.33301H19ZM20 16C19.632 16 19.3334 16.2981 19.333 16.666C19.333 17.0342 19.6318 17.333 20 17.333C20.3682 17.333 20.667 17.0342 20.667 16.666C20.6666 16.2981 20.368 16 20 16ZM16 12.666C15.2637 12.666 14.6672 13.2638 14.667 14C14.6672 14.7362 15.2637 15.333 16 15.333C16.7363 15.333 17.3328 14.7362 17.333 14C17.3328 13.2638 16.7363 12.666 16 12.666ZM12 10.666C11.6319 10.666 11.3332 10.965 11.333 11.333C11.333 11.7012 11.6318 12 12 12C12.3682 12 12.667 11.7012 12.667 11.333C12.6668 10.965 12.3681 10.666 12 10.666Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAccountTransfer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/account_transfer.5bda70da80ba4b443c45af7634f31278.svg";